import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { AlertController, AlertInput, IonButton, IonContent, IonIcon, IonInput, IonLabel, ModalController, Platform } from '@ionic/angular/standalone';
import { ApiService } from 'src/app/api.service';
import { EmailCredentials, Training } from 'src/app/app.types';
import { addIcons } from "ionicons";
import { mail, lockClosed, chevronBack, logoApple, logoGoogle, medical, personCircle, alertCircleOutline, alertCircle } from "ionicons/icons";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { AuthService } from 'src/app/auth.service';
import { Subscription } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';
import { App } from '@capacitor/app';
import { FirebaseError } from 'firebase/app';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        IonContent,
        IonButton,
        IonIcon,
        IonLabel,
        IonInput
    ]
})
export class AuthComponent implements OnDestroy, OnInit {

    private readonly auth = inject(AuthService)
    authSub: Subscription
    t: Training

    fromTraining = false

    signin = false
    remember: boolean
    ec: EmailCredentials = {
        email: "",
        pass: ""
    }

    suec: EmailCredentials = {
        email: "",
        pass: "",
        rpass: ""
    }

    public loginType = 0 // 0 social - 1 email - 2 new email account

    emailPattern = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
    passwordPattern = new RegExp(/^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>-])[A-Za-z\d!@#$%^&*(),.?":{}|<>-]{8,}$/)
    backButtonSub: Subscription

    constructor(
        public api: ApiService,
        private alertController: AlertController,
        private modalController: ModalController,
        private platform: Platform
    ) {
        App.addListener("backButton", (event) => {

        })

        addIcons({ mail, lockClosed, chevronBack, logoApple, logoGoogle, medical, personCircle, alertCircleOutline, alertCircle });
    }

    ngOnDestroy() {
        this.authSub.unsubscribe()
        this.backButtonSub.unsubscribe()
    }

    async ngOnInit() {

        this.platform.ready().then(() => {
            this.backButtonSub = this.platform.backButton.subscribeWithPriority(9999, () => {
                console.log("Back button pressed on AuthComponent")
            })
        })

        this.authSub = this.auth.authStateChange$.subscribe(async (u) => {
            console.log("authSub on AuthComponent")
            //this.modalController.dismiss({ user: u })
            if (u) {
                console.log("Found user, dismissing modal from auth service?")
                // if (this.fromTraining) {
                //     this.modalController.dismiss({ user: u })
                // } else {
                //     this.modalController.dismiss({ home: true })
                // }

            } else {
                console.log("No user on auth modal")
            }
        })




        const emailLogin = await this.api.getEmailLogin()
        if (emailLogin == "true") {
            console.log("emailLogin...")
            this.loginType = 1
            this.api.setEmailLogin("false")
        }


        // try {
        //     this.remember = await this.api.getRemember()
        //     if (this.remember) {
        //         let c = await this.api.getEmailCredentials()
        //         this.ec = c
        //     }
        // } catch (error) {
        //     console.log("remember not exists...", error.message)
        // }
    }



    rememberChanged() {
        console.log(this.remember)

    }

    async sendPasswordResetEmail() {
        const alertInputs: AlertInput[] = [
            {
                placeholder: 'E-mail',
                name: "email",
                type: "email",
                value: this.ec.email
            }
        ]

        const alert = await this.alertController.create({
            header: "Password dimenticata",
            message: "Vuoi davvero resettare la tua password attuale? Ti verrà inviata una mail per attivare la procedura.",
            inputs: alertInputs,
            buttons: [
                {
                    text: "Annulla",
                    role: "cancel"
                },
                {
                    text: "Resetta la password",
                    role: "destructive",
                    handler: async (alertData) => {
                        console.log("Sending reset to", alertData.email)
                        //await this.api.sendPasswordResetEmail(alertData.email)
                        await FirebaseAuthentication.sendPasswordResetEmail({
                            email: alertData.email
                        })
                        await this.api.showToast("Email di reset inviata correttamente", "checkmark")
                    }
                }
            ]
        })
        alert.present()

    }

    async signinWithEmail() {

        const restoreManualLogout = await this.auth.isManualLogoutPending()
        try {
            await this.auth.clearManualLogoutPending()
            await this.api.setRemember(this.remember)
            if (this.remember) {
                this.api.setEmailCredentials(this.ec.email, this.ec.pass)
            } else {
                this.api.removeEmailCredentials()
            }
            await FirebaseAuthentication.signInWithEmailAndPassword({
                email: this.ec.email,
                password: this.ec.pass
            })

        } catch (error) {
            if (restoreManualLogout) {
                await this.auth.setManualLogoutPending()
            }
            console.log(error.message)
            this.api.presentAlert("Errore", error.message)
        }

    }

    async signinWithGoogle() {

        this.signin = true
        const restoreManualLogout = await this.auth.isManualLogoutPending()
        try {
            await this.auth.clearManualLogoutPending()
            await FirebaseAuthentication.signInWithGoogle()

        } catch (e) {
            if (restoreManualLogout) {
                await this.auth.setManualLogoutPending()
            }

            // const err = error as any
            // console.log('RAW ERROR:', err)
            // console.log('keys:', Object.keys(err))
            // console.log('code:', err.code)          // expect 'auth/...'
            // console.log('message:', err.message)
            // console.log('name:', err.name)

            // const err = error as FirebaseError
            // console.log("FirebaseError", err)
            // if (error?.code === 'auth/multi-factor-auth-required') {
            //     console.log("auth/multi-factor-auth-required", error)
            // }

            // if (e instanceof FirebaseError &&
            //     e.code === 'auth/multi-factor-auth-required') {
            //     const resolver = getMultiFactorResolver(
            //         this.auth,
            //         e as MultiFactorError
            //     )
            // }


            // console.log(error, error.code)
            this.api.presentAlert("Attenzione", "Si è verificato un problema, si prega di riprovare")
            this.signin = false
        }


    }

    async signinWithApple() {

        this.signin = true
        const restoreManualLogout = await this.auth.isManualLogoutPending()
        try {
            await this.auth.clearManualLogoutPending()
            const res = await FirebaseAuthentication.signInWithApple()
            if (res.user) {
                //this.signin = false
                console.log("User signed with Apple")
            }
            this.signin = false
            // const nonce = this.randNonce(16)
            // const hashedNonceHex = CryptoES.SHA256(nonce).toString()
            // let options: SignInWithAppleOptions = {
            //     clientId: 'com.vivendo.tempo',
            //     redirectURI: 'https://tempo-85b92.firebaseapp.com/__/auth/handler',
            //     scopes: 'name email',
            //     state: '1256',
            //     nonce: hashedNonceHex
            // }

            // const res = await SignInWithApple.authorize(options)
            // if (res.response && res.response.identityToken) {
            //     const provider = new OAuthProvider("apple.com")
            //     const appleCredential = provider.credential({
            //         idToken: res.response.identityToken,
            //         rawNonce: nonce,
            //     })

            //     signInWithCredential(this.auth, appleCredential).then((uc) => {
            //         this.modalController.dismiss()
            //     }).catch((err) => {
            //         this.signin = false
            //         console.log("signinWithApple error: " + err)
            //     })
            //     this.signin = false
            // }
        } catch (error) {
            if (restoreManualLogout) {
                await this.auth.setManualLogoutPending()
            }
            console.log(error)
            this.api.presentAlert("Attenzione", "Si è verificato un problema, si prega di riprovare.")
            this.signin = false
        }


    }


    async signupWithEmail() {
        if (!Capacitor.isNativePlatform()) {
            this.loginType = 1
        }
        this.signin = true
        if (this.suec.email == "") return
        const restoreManualLogout = await this.auth.isManualLogoutPending()
        try {
            await this.auth.clearManualLogoutPending()
            await FirebaseAuthentication.createUserWithEmailAndPassword({
                email: this.suec.email,
                password: this.suec.pass
            })
            this.signin = false
        } catch (error) {
            if (restoreManualLogout) {
                await this.auth.setManualLogoutPending()
            }




            this.signin = false
            this.api.presentAlert("Attenzione", "Si è verificato un errore, si prega di riprovare. " + error.message)
        }


    }

    randNonce(length: number): string {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }

    isValidEmail() {
        const v = this.emailPattern.test(this.suec.email)
        return v
    }

    isValidPassword() {
        const v = this.passwordPattern.test(this.suec.pass)
        return v
    }



}
